import React from "react";

const baseClasses =
  "inline-flex h-12 w-full items-center justify-center rounded-md border border-transparent px-5 py-2 text-base font-semibold transition duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-900 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60";

const Button = ({
  type = "button",
  onClick,
  children,
  className = "",
  disabled = false,
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`${baseClasses} bg-slate-900 text-white hover:bg-slate-800 active:enabled:translate-y-px ${className}`}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;
